import { useLanguage } from '../../providers/preferenceProvider';
import '../../css/bookingListEntry.css';
import { formatDate, formatDateToTime } from '../../utils/dateTimeUtils';
import { useEffect, useRef, useState } from 'react';
import { getAllowedExtensions, updateExtendBooking } from '../../api/booking-api';
import { useToast } from '../../providers/toastProvider';
import { useConfig } from '../../providers/configProvider';
import { ACL } from '../../acls';

const BookingListEntry = ({ booking, onBookingClick, refreshBookings, elementColor }) => {
  const { t } = useLanguage();
  const [allowedExtensions, setAllowedExtensions] = useState(null);
  const [showExtensions, setShowExtensions] = useState(false);
  const extendBookingRef = useRef(null)
  const { showToast } = useToast();
  const { isAuthorized, refresh, config } = useConfig();

  useEffect(() => {
    if (isActiveBooking()) {
      setExtendOptions();
    }
  }, [booking])

  async function setExtendOptions() {
    const options = (await getAllowedExtensions(booking.id, booking.roomId)).data;
    
    if (options?.length > 0) {
      setAllowedExtensions(options);
    }
  }

  function isActiveBooking() {
    return new Date(booking.endTime) > new Date() && 
      new Date(booking.startTime) < new Date();
  }

  function extendBooking(interval) {
    updateExtendBooking(booking.id, interval).then( () => {
      showToast(`Booking extended by ${interval} minutes`, 'success');
      setShowExtensions(false);
      refreshBookings?.();
      refresh(); // config
    })
  }

  function isCreator() {
    const user = booking?.Users?.find(user => config.user.id === user.id);
    return user?.UserBooking?.creator === true;
  }

  return (
    <div className={`drop-shadow-lg rounded-xl grid grid-cols-1 md:grid-cols-[4fr_3fr] bg-[${elementColor ? `${elementColor}` : ''}] booking-list-entry w-full ${isActiveBooking() ? 'booking-list-entry-active' : ''}`}>
      <div className='flex flex-row gap-4 items-center'>
        <div className="room-picture">
          <img src={booking.Room.image} alt="42Workspace" onClick={() => onBookingClick(booking)} className='cursor-pointer' />
        </div>
        <div className="booking-info max-md:hidden">
          <div> {booking.title}</div>
          <div> {booking.Room.name}</div>
          <div> {formatDate(booking.startTime)}</div>
          <div> {formatDateToTime(booking.startTime)} - {formatDateToTime(booking.endTime)}</div>
        </div>
      </div>
      <div className="button-wrapper">
        {
          (isActiveBooking() && isCreator()) ? (
            <>
              {( allowedExtensions && showExtensions ?
                <div ref={extendBookingRef} className={`flex flex-row gap-2 items-center transition transition-all ease-in-out duration-50 ${(showExtensions ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0')}`}>
                  {allowedExtensions.map((entry, idx) =>
                  {
                    return <button onClick={() => extendBooking(entry.interval)} className='px-4 py-2'>{entry.interval}m {isAuthorized(ACL.USE_CREDITS) ? `${entry.credits} credits` : null}</button>
                  }
                  )}
                </div> 
                : 
                <div className={(showExtensions ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0')}>{t.cannot_extend}</div>)}
              <button onClick={() => setShowExtensions(!showExtensions)}>
                <div>{t.extend_booking}</div>
              </button>
            </>
          ) : null
        }
        <button onClick={() => onBookingClick(booking)}>
          <div>{t.manage_booking}</div>
        </button>
      </div>
    </div>
  );
};

export default BookingListEntry;